import { Component,OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog,MdDialogRef } from '@angular/material';
import { HttpService } from '../../shared/services/http.service'
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { Subject }    from 'rxjs/Subject';
import { dialogComponent } from '../../dialog/dialog.component';
import { TranslateService } from 'ng2-translate';


@Component({
    selector: 'add-new-address',
    template: require('./addNewAddress.component.html'),
    styles: [require('./addNewAddress.component.scss'),require('../../style.scss')],
    providers: [HttpService,SessionHandler]
})
export class addNewAddressComponent implements OnInit {
    street:any;
    postalCode:any;
    city:any;
    country:any;
    streetValid:boolean = false;
    postalCodeValid:boolean = false;
    cityValid:boolean = false;
    countryValid : boolean = false;
    new_address :any;
    isIcb:boolean = false;
    saving = false;
    dialogRef;
    tradeId:any;
    MAX_COUNTRY_CODE:any = 2;
    MAX_POSTAL_CODE:any = 9;
    MAX_CITY:any = 30;
    MAX_STREET:any = 35;
    filteredCountryCodeList: any[] = [];
    countryError: string = '';

countryCodeList: any[] = [];


    constructor(private router: Router,private http:HttpService,private translate: TranslateService,private commonService:CommonService,
        private sessionHandler:SessionHandler,private dialog: MdDialog,private dialogRefSelf: MdDialogRef<addNewAddressComponent>) {}
    ngOnInit():void {
      
    }
    ngAfterViewInit(){
 this.loadCountryCodes();
    }
loadCountryCodes() {
    this.http.getRequest('masterData/v1/getCountryCodes').subscribe(
        (res: any) => {

            if (res && res.countryCodes) {

                this.countryCodeList = Object.keys(res.countryCodes).map(name => ({
                    name: name,
                    code: res.countryCodes[name]
                })).sort((a, b) => a.name.localeCompare(b.name));

                this.filteredCountryCodeList = this.countryCodeList;
   
                console.log(this.countryCodeList);
            }else{
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Failed to load country codes.';
            }
            this.http.onEnd();
        },
        err => {
            console.error(err);
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err.message || 'Failed to load country codes.';
            this.http.onEnd();
        }
        
    );
}
onCountryChange(value: string) {
    this.country = value;

    if (!value) {
        this.filteredCountryCodeList = this.countryCodeList;
        this.countryValid = false;
        this.countryError = '';
        return;
    }

    const search = value.toLowerCase();

    this.filteredCountryCodeList = this.countryCodeList.filter(c =>
        c.code.toLowerCase().includes(search) ||
        c.name.toLowerCase().includes(search)
    );

    const exactMatch = this.countryCodeList.find(c =>
        c.code.toLowerCase() === search ||
        c.name.toLowerCase() === search
    );

    if (exactMatch) {
        this.country = exactMatch.code;
        this.countryValid = true;
        this.countryError = '';
    } else {
        this.countryValid = false;
        this.countryError = 'Please select a valid country code.';
    }
}

    public closeDialog(){
        this.dialog.closeAll();
    }
    public newAddressValidation(field,evt) {
        if(field == 'street') {
            if (!this.street || this.street == '')  {
                this.streetValid = false;
            } else {
                this.streetValid = true;
            }
        }
        if(field == 'postalCode') {
            if (!this.postalCode || this.postalCode == '' || this.postalCode.length < 4)  {
                this.postalCodeValid = false;
            } else {
                this.postalCodeValid = true;
            }
        }
        if(field == 'city'){
            if (!this.city || this.city ==''){  
                this.cityValid = false;
            } else {
                this.cityValid = true;
            }
        }
        if(field == 'country'){
            const match = this.countryCodeList.find(c =>
                        c.code === this.country);
            this.countryValid = !!match;
        }
    }
    public saveNewAddress(){
        if (this.saving) return;
         const countryMatch =this.countryCodeList.find(c => c.code === this.country);
        if (!countryMatch) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg ='Please select a valid country code.';
            return;
        }
        if(this.postalCodeValid && this.cityValid && this.streetValid) {
            this.saving = true;
            this.dialogRefSelf.close();
            this.http.showLoader();
            this.new_address={};
            this.new_address.tradePartnerId = this.tradeId;
            this.new_address.city = this.city;
            this.new_address.zipCode = this.postalCode;
            this.new_address.street = this.street;
            this.new_address.country = this.country;
            // console.log(this.new_address)
            this.http.postRequest(this.new_address,'address/v1/saveAddress').subscribe(
            res => {
                    this.saving = false;
                    if(res['responseCode']==200){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = this.translate.instant('address_added_success');
                        this.http.onEnd();
                        this.dialogRef.afterClosed().subscribe(result => {
                            if(result) {
                                this.commonService.changeAddressData();
                                this.commonService.changeCurrentAddress(res['id']);
                            }
                            this.dialogRef = null;
                        });
                    }else{
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = res['status'];
                        this.http.onEnd();
                    }
                },
                err => {
                    this.saving = false;
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                }
            );
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/details/addNewAddress.component.ts